import React from 'react'
import {ListGuesser, FieldGuesser} from '@api-platform/admin'
import {Filter, TextInput, TextField, ReferenceField} from 'react-admin'
import ListPagination from "../../../components/admin/ListPagination"

import PostBulkActionButtons from "../../../components/admin/PostBulkActionButtons";
import ListActions from "../../../components/admin/Actions";
import {useTranslation} from "react-i18next";

function List(props) {
    const {t} = useTranslation()
    return (
        <ListGuesser
            perPage={30}
            title={t('menu.companies')}
            pagination={<ListPagination/>}
            {...props}
            filters={<Filter>
                <TextInput label={t('common.name')} source="name"/>
                <TextInput label={t('brief.company')} source="company.name"/>
            </Filter>}
            bulkActionButtons={<PostBulkActionButtons
                //showExportButton={true}
                showDeleteButton={true/*Roles.hasAccess('ClientsEdit')*/}
            />}
            actions={<ListActions
                showNewButton={true/*Roles.hasAccess('ClientsEdit')*/}
                //showExportButton={true}
            />}
        >
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
            <ReferenceField source="company" reference="dictionary/companies" link={false} label={t('brief.company')}
                            sortable={false}>
                <TextField source="name"/>
            </ReferenceField>
            <TextField source="mpmId" label={'mpmId'}/>
        </ListGuesser>
    )
}

export default List
